import React from 'react';
export function BeforeAfterGallery() {
  const comparisons = [{
    label: 'Interior Restoration',
    after: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/218eec05-d8c7-475f-8a9a-a8b83649c057/Jeep-Interior-Detailing-Phoenix-scaled.jpg'
  }, {
    label: 'Modern Tech Clean',
    after: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/26c54967-9d7d-4362-bfbc-55a4aeed2e1c/Cyber-Truck-Interior-Detailing-Phoenix-scaled.jpg'
  }, {
    label: 'Luxury Finish',
    after: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/9c7d4f8e-b410-418d-bc6b-65e3c3c0a87b/Corvette-Interior-Detailing-Phoenix-scaled.jpg'
  }];
  return <section className="py-20 md:py-32 bg-[#111111]" data-id="element-1">
      <div className="container mx-auto px-4 md:px-6" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-black text-white uppercase mb-4" data-id="element-4">
            Our Detailing Showcase
          </h2>
          <div className="w-24 h-1 bg-[#7FD4D4] mx-auto" data-id="element-5"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-6">
          {comparisons.map((item, index) => <div key={index} className="flex flex-col" data-id="element-7">
              <h3 className="text-white font-bold text-lg md:text-xl mb-4 font-montserrat" data-id="element-8">
                {item.label}
              </h3>
              <div className="relative h-56 md:h-80 w-full rounded-sm overflow-hidden border border-white/10 group" data-id="element-9">
                {/* We simulate a before/after by just showing the high quality after image and a grayscale version as 'before' side by side for this demo since we don't have perfect matching pairs */}
                <div className="absolute inset-0 flex" data-id="element-10">
                  <div className="w-1/2 h-full relative overflow-hidden border-r-2 border-[#7FD4D4]" data-id="element-11">
                    <div className="absolute inset-0 bg-black/40 z-10 flex items-center justify-center" data-id="element-12">
                      <span className="bg-black/70 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-13">
                        BEFORE
                      </span>
                    </div>
                    <img src={item.after} alt="Before" className="absolute inset-0 w-[200%] h-full object-cover grayscale filter brightness-75" style={{
                  left: '0'
                }} data-id="element-14" />
                  </div>
                  <div className="w-1/2 h-full relative overflow-hidden" data-id="element-15">
                    <div className="absolute inset-0 z-10 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-16">
                      <span className="bg-[#7FD4D4] text-black text-xs font-bold px-2 py-1 rounded" data-id="element-17">
                        AFTER
                      </span>
                    </div>
                    <img src={item.after} alt="After" className="absolute inset-0 w-[200%] h-full object-cover" style={{
                  left: '-100%'
                }} data-id="element-18" />
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}